import { ArrowNarrowRightIcon } from '@langchain/untitled-ui-icons';

import { Link } from 'react-router-dom';

import { useWorkspaceId } from '@/hooks/useSwr';
import { ResourceType } from '@/types/schema';
import { appOrganizationPath } from '@/utils/constants';
import { cn } from '@/utils/tailwind';

import { HomeAnnotationQueuesTable } from './ResourceTable/HomeAnnotationQueuesTable';
import { HomeDashboardsTable } from './ResourceTable/HomeDashboardsTable';
import { HomeDatasetsTable } from './ResourceTable/HomeDatasetsTable';
import { HomeHostsProjectsTable } from './ResourceTable/HomeHostsProjectsTable';
import { HomePromptsTable } from './ResourceTable/HomePromptsTable';
import { HomeTracingProjectsTable } from './ResourceTable/HomeTracingProjectsTable';
import { RESOURCE_DETAILS_MAPPING } from './constants';

const resourceComponentMap = {
  [ResourceType.Project]: HomeTracingProjectsTable,
  [ResourceType.Dashboard]: HomeDashboardsTable,
  [ResourceType.Dataset]: HomeDatasetsTable,
  [ResourceType.Queue]: HomeAnnotationQueuesTable,
  [ResourceType.Prompt]: HomePromptsTable,
  [ResourceType.Deployment]: HomeHostsProjectsTable,
} as const;
export function ResourceSection(props: {
  resourceType: ResourceType;
  isEmpty: boolean;
}) {
  const Component = resourceComponentMap[props.resourceType];
  const content = Component ? <Component /> : null;

  return (
    <div className="min-h-380px flex flex-col gap-4 pt-2">
      {content}
      <div
        className={cn(
          'flex items-center gap-2',
          props.resourceType === ResourceType.Project
            ? 'justify-between'
            : 'justify-end'
        )}
      >
        {props.resourceType === ResourceType.Project && (
          <div className="text-xs text-quaternary">
            Showing 5 most active projects.
          </div>
        )}
        {!props.isEmpty && (
          <ViewAllLink
            resourceType={props.resourceType}
            className="flex items-center gap-1 place-self-end border-b border-ls-black pb-1 text-xs"
          />
        )}
      </div>
    </div>
  );
}

function ViewAllLink(props: {
  resourceType: ResourceType;
  className?: string;
}) {
  const workspaceId = useWorkspaceId();
  const { path, label, viewAllLabel } =
    RESOURCE_DETAILS_MAPPING[props.resourceType];

  const link =
    props.resourceType === ResourceType.Prompt
      ? `/${path}?organizationId=${workspaceId}`
      : `/${appOrganizationPath}/${workspaceId}/${path}`;

  return (
    <Link to={link} className={props.className}>
      {viewAllLabel ?? label} <ArrowNarrowRightIcon className="h-4 w-4" />
    </Link>
  );
}
